export var StaticAssets = 'https://statics.olx.in';
export var X = '1x';
export var XX = '2x';
export var XXX = '3x';
export var WEBP_EXT = 'webp';
export var PNG_EXT = 'png';
export var SVG_EXT = 'svg';
export var GIF_EXT = 'gif';
export var JPG_EXT = 'jpg';
export var WEBP_PNG_TYPE = [WEBP_EXT, PNG_EXT];
export var MODE = {
  LIGHT: 'light',
  DARK: 'dark'
};
export var WIDTH_320 = '320';
export var WIDTH_360 = '360';
export var WIDTH_480 = '480';
export var WIDTH_1280 = '1280';
export var WIDTH_2560 = '2560';
export var WIDTH_3840 = '3840';
export var WIDTH_34 = 34;
export var WIDTH_58 = 58;
export var HEIGHT_34 = 34;
export var HEIGHT_58 = 58;
export var THRESHOLD_SCROLL = 20;
export var DEFAULT_HEIGHT = 10;
export var DEFAULT_WIDTH = 10;
export var mobileSupportedWidths = [WIDTH_320, WIDTH_360, WIDTH_480];
export var desktopSupportedWidths = [WIDTH_1280, WIDTH_2560, WIDTH_3840];